import {
  Directive
} from '@angular/core';

@Directive({
  selector: '[mdl-menu-item-full-bleed-divider]',
  host: {
    '[class.mdl-menu__item--full-bleed-divider]': 'true'
  }
})
export class MdlMenuItemFullBleedDeviderComponent {

}



// WEBPACK FOOTER //
// ./src/lib/components/menu/mdl-menu-item.directive.ts